import React, { Component } from 'react';
import PDF from 'react-pdf-js';
import T from 'i18n-react';
import { withFormik } from 'formik';
import Yup from 'yup';
import InputFeedback from './InputFeedback';

export default class LoaSigningForm extends Component {
  render() {
    return <MyEnhancedForm
      Loa={this.props.Loa}
      handleSign={this.props.handleSign}
    />
  }
}

const isVisa = (loa) => {
  return loa.claimsPassengerTicket.claim.affiliate.name.toLowerCase().indexOf("visa") !== -1
}

const formikEnhancer = withFormik({
  validationSchema: (props)=>{
    const loa = props.Loa;
    const errMess = <div>
        <T.text tag='h3' text={{key: "errHeader"}}/>
        <T.span text={{key: "errBody"}}/>
      </div>;
    const shape = {
      tcConsent: Yup.bool()
        .required(errMess)
        .oneOf([true], errMess),
      loaConsent: Yup.bool()
        .required(errMess)
        .oneOf([true], errMess),
      personalDataConsent: Yup.bool()
        .required(errMess)
        .oneOf([true], errMess),
    }
    if(isVisa(loa)){
      shape.visaConsent = Yup.bool()
        .required(errMess)
        .oneOf([true], errMess);
      shape.visaCardName = Yup.string()
        .required(errMess)
    }
    if (!loa.adult){
      shape.minorGuardian = Yup.string()
        .required(errMess);
    }
    return Yup.object().shape(shape)
  },

  mapPropsToValues: (props) => ({
    minorGuardian: "",
    visaConsent: "",
    visaCardName: "Visa Business",
    tcConsent: "",
    loaConsent: "",
    personalDataConsent: ""
  }),

  handleSubmit: (values, { props, setSubmitting }) => {
    let loa = {
      tcConsent: values.tcConsent,
      loaConsent: values.loaConsent,
      personalDataConsent: values.personalDataConsent
    }
    if (isVisa(props.Loa)) {
      loa.visaConsent = values.visaConsent;
      loa.visaCard = values.visaCardName;
    }
    if (!props.Loa.adult) {
      loa.guardianFullName = values.minorGuardian;
    }

    if(typeof props.handleSign === 'function'){
      props.handleSign(loa)
    }
    setSubmitting(false);
  },
  displayName: 'MyForm',
});


class MyForm extends Component {
  createMarkup() {
    return {__html: T.translate("t&cConsent")};
  }

  render() {
    const loa = this.props.Loa;
    const {
      values,
      errors,
      touched,
      handleChange,
      handleBlur,
      isSubmitting,
      handleSubmit
    } = this.props;    
    return(
      <div className="loa-signing-form">
          <InputFeedback error={
            (touched.minorGuardian && errors.minorGuardian) || (touched.tcConsent && errors.tcConsent) ||
            (touched.loaConsent && errors.loaConsent) || (touched.visaConsent && errors.visaConsent) ||
            (touched.personalDataConsent && errors.personalDataConsent)} />
        {
          loa && loa.loaDocumentUrl ?
            <div className="pdf-container">
              <PDF
                file={loa.loaDocumentUrl}
                fillWidth
                fillHeight
                className="pdf-viewer"
              />
            </div>
            :
            null
        }
        <a className="download-link" href={loa && loa.loaDocumentUrl} download="LOA.pdf" target="_blank">
          {T.translate("downloadButtun")}
        </a>
        <form className="loa-form" onSubmit={handleSubmit}>

          {
            loa && loa.adult ?
              null
              :
              <div className="row minor-row">
                <label htmlFor="visaConsent">
                  {T.translate("minorParagraph")}
                </label>
                <div>
                  <input
                    id="minorGuardian"
                    name="minorGuardian"
                    type="text"
                    placeholder={T.translate("inputHint")}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.minorGuardian} />
                  <span className="required">*</span>
                </div>
              </div>
          }

          <div className="row tandc-consent-row">
            <input
              type="checkbox"
              id="tcConsent"
              name="tcConsent"
              value={values.tcConsent}
              checked={values.tcConsent}
              onChange={handleChange}
              onBlur={handleBlur}/>
            <label htmlFor="tcConsent" dangerouslySetInnerHTML={this.createMarkup()}>
            </label>
          </div>
          <div className="row loa-consent-row">
            <input
              type="checkbox"
              id="loaConsent"
              name="loaConsent"
              value={values.loaConsent}
              onChange={handleChange}
              onBlur={handleBlur}/>
            <label htmlFor="loaConsent">
              {T.translate("loaConsent")}
            </label>
          </div>
          <div className="row">
            <input
              type="checkbox"
              id="personalDataConsent"
              name="personalDataConsent"
              value={values.personalDataConsent}
              onChange={handleChange}
              onBlur={handleBlur}/>
            <label htmlFor="personalDataConsent">
              {T.translate("personalDataConsent")}
            </label>
          </div>

          {
            isVisa(loa) ?
              <div className="row visa-consent-row">
                <input
                  type="checkbox"
                  id="visaConsent"
                  name="visaConsent"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.visaConsent} />
                <label htmlFor="visaConsent">
                  {T.translate("visaConsent")}&nbsp;
                  <select
                    name="visaCardName"
                    onChange={handleChange}>
                    <option value="Visa Business" defaultValue>Visa Business</option>
                    <option value="Visa Business Electron">Visa Business Electron</option>
                    <option value="Visa Classic">Visa Classic</option>
                    <option value="Visa Electron">Visa Electron</option>
                    <option value="Visa Gold">Visa Gold</option>
                    <option value="Visa Gold Business">Visa Gold Business</option>
                    <option value="Visa Infinite">Visa Infinite</option>
                    <option value="Visa Infinite Business">Visa Infinite Business</option>
                    <option value="Visa Infinite Corporate">Visa Infinite Corporate</option>
                    <option value="Visa Platinum">Visa Platinum</option>
                    <option value="Visa Platinum Business">Visa Platinum Business</option>
                    <option value="Visa Platinum Corporate">Visa Platinum Corporate</option>
                    <option value="Visa Premier">Visa Premier</option>
                    <option value="Visa Premium Corporate">Visa Premium Corporate</option>
                    <option value="Visa Public">Visa Public</option>
                  </select>
                  <br/>{T.translate("additionalParagraph")}
                </label>
              </div>
              :
              null
          }

          <div className="row sumbmit-btn-row">
            <input
              type="submit"
              name="submit"
              value={T.translate("signButton")}
              className="submit-btn"
              disabled={isSubmitting}/>
          </div>
        </form>
      </div>
    )
  }
}

const MyEnhancedForm = formikEnhancer(MyForm);



// WEBPACK FOOTER //
// ./src/components/LoaSigningForm.js